import { FinancialStatus, IOrder, OrderStatus } from '@monofront/types';
import { getFinancialStatus, getOrderStatus } from '@monofront/business/utils';
import { useTranslations } from 'next-intl';

interface IStatusProps {
  order: IOrder;
  align?: 'center' | 'left' | 'right';
}

const alignMap = {
  center: 'tw-items-center',
  left: 'tw-items-start',
  right: 'tw-items-end',
};

const statusLevels: { [key in OrderStatus]: string } = {
  prepared: 'tw-lf-tag-decorative-green',
  cancelled: 'tw-lf-tag-decorative-red',
  pending: 'tw-lf-tag-decorative-yellow',
};

const financialStatusLevels: {
  [key in
    | FinancialStatus.REFUNDED
    | FinancialStatus.PARTIALLY_REFUNDED]: string;
} = {
  [FinancialStatus.REFUNDED]: 'tw-lf-tag-decorative-red',
  [FinancialStatus.PARTIALLY_REFUNDED]: 'tw-lf-tag-decorative-red',
};

export const Status: React.FC<IStatusProps> = ({ order, align = 'left' }) => {
  const status = getOrderStatus(order);
  const financialStatus = getFinancialStatus(order);

  const tOrderStatus = useTranslations('OrderStatus');
  const tFinancialStatus = useTranslations('FinancialStatus');

  return (
    <>
      <div
        className={`status tw-flex tw-flex-col ${alignMap[align]} tw-gap-2	 [&>*]:tw-max-w-min`}
      >
        <p className={`tw-lf-tag tw-lf-tag-md ${statusLevels[status]}`}>
          {tOrderStatus(status)}
        </p>

        {financialStatus && (
          <p
            className={`tw-lf-tag tw-lf-tag-md ${financialStatusLevels[financialStatus]} tw-h-fit tw-whitespace-normal tw-break-words`}
          >
            {tFinancialStatus(financialStatus)}
          </p>
        )}
      </div>
      <style jsx>{`
        .status > :global(div) {
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </>
  );
};
